import * as cheerio from 'cheerio';

export function callGopher(gopherDataJson, gopherThen, gopherFail) {
    window.SPAUTH.login().then((user) => {
        const gopherProxy = '/api/v2';

        const gopherHeaders = {
            'Content-Type': 'application/json'
        }

        gopherDataJson.script_params.user_name = user.username;
        gopherDataJson.agent = "DVSWeb 2.0";
        gopherDataJson.script_params.dry_run = "false";
        gopherDataJson.script_params.environment= process.env.NODE_ENV === "development" ? "dev" : window.location.host.split(".")[1] === "web" ? "live" : "qa";

        fetch(gopherProxy + "/execute", {
            method: 'POST',
            headers: gopherHeaders,
            body: JSON.stringify(gopherDataJson)
        })
        .then(response => {
            if (response.status !== 201) {
                throw Error("Expected a 201 response code but got " + response.status);
            }

            const location = response.headers.get("Location");
            console.log(`location: ${location}`);
            return new URL(location).pathname;
        })
        .then(redirect => {
            let retries = 5;
            let poll = 1000;

            const location = redirect + "?details=true"
            console.log("checking gopher execution status at " + location);

            return new Promise(function (resolve, reject) {
                (function waitForCompleted(){
                    if (retries === 0) {
                        console.log("timeout reached waiting for confirmation of successful gopher execution");
                        return reject();
                    }
                    console.log("fetching gopher execution status endpoint");
                    fetch(location, {
                        headers: gopherHeaders
                    })
                    .then(response => response.json())
                    .then(body => {
                        if (body.completed === 1) {
                            console.log("gopher execution completed");
                            return resolve({"status": "success"});
                        }
                        retries--
                        poll+= poll
                        setTimeout(waitForCompleted, poll);
                    })
                })();
            })
            .then(gopherThen)
            .catch(gopherFail);
        });
    });
}

function findParent(pi,diff){
    const $previousSegment = cheerio.load(diff[pi].value);
    const $previous = $previousSegment('window-preferences-override,portlet-preferences-override').last();
    if( $previous.length === 0 ){
        return findParent(pi-1,diff);
    }
    return $previous;
};

export function convertDiff(diff, reverse) {
    const direction = reverse ? 'added' : 'removed';
    const otherDirection = reverse ? 'removed' : 'added';
    const childlessTags = ['themekit', 'variation-ref', 'profile-ref', 'oem-profile-ref', 'group-profile-ref', 'redirect-ref', 'package-ref', 'package-family', 'content-set', 'account-id', 'homepage'].join();
    let xmlDiff = diff.map((D, i) => {
        let {v, ...formattedXml} = D;
        if( D.removed || D.added ){
            let $ = cheerio.load(D.value, { withDomLvl1: true, normalizeWhitespace: false, xmlMode: true, decodeEntities: false });
            if(D[direction]) {
                $('*').each(function () {
                    $(this).attr('remove', 'true');
                    if ($(this).is(childlessTags)) {
                        formattedXml[direction] = false;
                    }
                    if($(this).is('preference')){
                        const value = $(this).attr('value');
                        $(this).attr('valueMatch',value);
                        $(this).attr('value', null)
                    }
                });
            } else if (D[otherDirection]) {
                $('*').each(function () {
                    if($(this).is('entry')){
                        $(this).attr('replace','true');
                    }
                });
            }
            let $preference = $('preference');
            if( $preference.length && !$preference.parent('window-preferences-override,portlet-preferences-override').length ){
                const $parent = findParent(i-1,diff);
                const parentType = $parent.is('window-preferences-override') ? 'window-preferences-override' : 'portlet-preferences-override';
                const attrType = parentType === 'window-preferences-override' ? 'id' : 'name';
                const widget = $parent.attr(attrType);
                formattedXml.value = `<${parentType} ${attrType}="${widget}">\n${$.html()}</${parentType}>`;
            } else {
                formattedXml.value = $.html();
            }
        }
        return formattedXml;
    });
    return xmlDiff.filter( D => D.added || D.removed).sort( D => D[otherDirection]);
}